import { Col, Input } from 'antd';
import { useHistory } from 'react-router';

import LauBgImg from 'images/hometaste-order-tracking-background.png';
import LouBgImg from 'images/lft-order-tracking-background.png';
import brand from 'config/brand';
import { getOrderStatusTrackingRoute } from 'utils/routes';

import { BgDeliveryImgContainer, BgDeliveryImg, ContentContainer, HeaderRow, RootContainer, SearchContainer } from './OrderStatusSearch.styles';

const { Search } = Input;

const BgImg = brand.id === 'lou-fo-tong' ? LouBgImg : LauBgImg;

const OrderStatusSearch = () => {
  const history = useHistory();

  const _onSearch = value => history.push(getOrderStatusTrackingRoute(value).path);

  return (
    <RootContainer>
      <HeaderRow>
        <Col>
          <img src={brand.logoPath} width="200" height="auto" alt={brand.displayName} />
        </Col>
      </HeaderRow>
      <ContentContainer>
        <SearchContainer>
          <h1>Want to check on your order's delivery progress?</h1>
          <h3 style={{ color: '#8c8c8c' }}>Enter your order number to get current update</h3>
          <Search placeholder="E.g.: 1234567" onSearch={_onSearch} enterButton />
        </SearchContainer>
        <BgDeliveryImgContainer>
          <BgDeliveryImg src={BgImg} alt={`${brand.displayName} delivery order tracking system`} width="100%" height="auto" />
        </BgDeliveryImgContainer>
      </ContentContainer>
    </RootContainer>
  );
};

export default OrderStatusSearch;
